import React, { Component } from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import SearchBox from 'react-google-maps/lib/components/places/SearchBox';
import { InfoBox } from 'react-google-maps/lib/components/addons/InfoBox';
import { isEmpty } from '../../helpers/utils';
import clinicMarker from '../../images/clinicMarker.png';

class Map extends Component {
  constructor(props) {
    super(props);
    this.searchBoxRef = React.createRef();
    this.state = {
      position: { lat: -34.8596, lng: -56.2138 },
      lastSearchedPosition: null,
      zoom: 11,
      activeMarker: null,
    };
  }

  onPlacesChanged = () => {
    const place = this.searchBoxRef.current.getPlaces()[0];
    const bounds = new window.google.maps.LatLngBounds();

    if (place.geometry.viewport) {
      bounds.union(place.geometry.viewport);
    } else {
      bounds.extend(place.geometry.location);
    }

    const { geometry: { location: { lat, lng } } } = place;
    this.setState({
      position: { lat: lat(), lng: lng() },
      lastSearchedPosition: { lat: lat(), lng: lng() },
      zoom: 16,
    });
  };

  onSelectMarker = (activeMarker, latitude, longitude) => (
    this.setState(prevState => {
      if (activeMarker === null || prevState.activeMarker === activeMarker) {
        return { activeMarker: null };
      }

      return { activeMarker, position: { lat: latitude, lng: longitude } };
    })
  );

  render() {
    const { clinics } = this.props;
    const { activeMarker, position, lastSearchedPosition, zoom } = this.state;

    return (
      <GoogleMap
        defaultZoom={11}
        defaultCenter={{ lat: -34.8296, lng: -56.2138 }}
        options={{ mapTypeControl: false, fullscreenControl: false, streetViewControl: false }}
        mapElement={<div style={{ height: '100%' }} />}
        center={position}
        zoom={zoom}
      >
        <SearchBox
          ref={this.searchBoxRef}
          controlPosition={window.google.maps.ControlPosition.TOP_LEFT}
          onPlacesChanged={this.onPlacesChanged}
        >
          <input
            type="text"
            placeholder="Buscar dirección"
            className="map-searchbox"
          />
        </SearchBox>
        {clinics.map((clinic, index) => {
          const { latitude,
            longitude,
            fullName,
            phoneNumber,
            street,
            number,
            apartmentNumber,
            corner,
            specialties,
          } = clinic;

          return latitude && longitude && (
            <Marker
              key={index}
              position={{ lat: latitude, lng: longitude }}
              onClick={() => this.onSelectMarker(index, latitude, longitude)}
              icon={{
                url: clinicMarker,
                size: { width: 28, height: 42 },
                anchor: { x: 14, y: 42 },
                scaledSize: { width: 28, height: 42 },
              }}
              >
              {activeMarker !== null && activeMarker === index && (
                <InfoBox onCloseClick={() => this.onSelectMarker(null)}>
                  <div className="map-infobox">
                    <h3>{fullName}</h3>
                    <label>Dirección</label>
                    <span>{`${street} ${number} ${apartmentNumber} ${!isEmpty(corner) && `Esq. ${corner}`}`}</span>
                    {!isEmpty(phoneNumber) && [
                      <label key="label">Teléfono</label>,
                      <span key="phoneNumber">{phoneNumber}</span>,
                    ]}
                    {!isEmpty(specialties) && [
                      <label key="label">Especialidad</label>,
                      <span key="specialties">{specialties}</span>,
                    ]}
                  </div>
                </InfoBox>
              )}
            </Marker>
          )
        })}
        {lastSearchedPosition && <Marker position={lastSearchedPosition} />}
      </GoogleMap>
    );
  }
}

export default withScriptjs(withGoogleMap(Map));
